export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M14 6H5v3h9V6zM3 4v7h3.983l-2.3093 4H3v6h11v-6h-3.5445l2.3094-4H16V9h2V8h3V6h-3V5h-2V4H3zm7.4555 7-2.3094 4H6.983l2.3094-4h1.163zM5 17h7v2H5v-2z" } }];
export const iconName = 'drill';
export const drill = { iconName, paths };
export default paths;
